// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__t2UiX","rootCenter":"LoadMoreObserver_rootCenter__2Ej2k","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__paxLL"};